let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2y2gh")).then(() => parcelRequire('f45ZV'));